import errorHelpers from '../helpers/errors';
import IBooking from '../interfaces/IBooking';
import { IPostGamePurchase } from '../interfaces/IPostGamePurchase';

class PremiumPtv {
    static GetPostGamePurchaseDetails = (
        venue: string,
        gameResultId: number,
        playerGuid: string
    ): Promise<IPostGamePurchase> => {
        return fetch(`/addons/${venue}/post-game-purchase?gameResultId=${gameResultId}&playerGuid=${playerGuid}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        })
            .then((response) => errorHelpers.handleErrors(response))
            .then((response) => response.json() as Promise<IPostGamePurchase>);
    };
    
    static ConsumeCredits = (
        venue: string,
        bookingId: number,
        buyerGuid: string,
        playerGuids: string[]
    ): Promise<IBooking> => {
        return fetch(`/addons/${venue}/consume-credits`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                bookingId,
                consumedByPlayerGuid: buyerGuid,
                playerGuids
            })
        })
            .then((response) => errorHelpers.handleErrors(response))
            .then((response) => response.json() as Promise<IBooking>);
    };
}

export default PremiumPtv;
